import FetchAutocomplete from './FetchAutocomplete';

export default FetchAutocomplete;
